import { SET_COLLISION_DATA, SET_CURRENT_POSITION } from './constants';

export const setCollisionData = (collisionData) => ({
  type: SET_COLLISION_DATA,
  payload: collisionData,
});

export const setCurrentPosition = (position) => ({
  type: SET_CURRENT_POSITION,
  payload: position,
});
